<template>
  <DefaultBackground>
    <div class="p-5 flex justify-center">
      <SignIn @forgot="$router.push('/forgot-password')" @success="onSuccess">
        <div slot="footer" class="text-center mt-10 mb-5">
          <a href="javascript:" class="text-primary" @click="$router.push('/auth/sign-up')">
            Don't have account? SignUp!!!
          </a>
        </div>
      </SignIn>
    </div>
  </DefaultBackground>
</template>

<script>
  import DefaultBackground from "../../components/common/layout/DefaultBackground"
  import SignIn from "../../components/common/auth/SignIn"
  import { mapGetters } from "vuex"

  export default {
    components: {
      SignIn,
      DefaultBackground
    },
    data() {
      return {
        loading: false,
        errors: {}
      }
    },
    computed: {
      ...mapGetters([
        'redirectAfterAuthUrl'
      ])
    },
    methods: {
      onSuccess() {
        this.$router.push(this.redirectAfterAuthUrl)
      }
    }
  }
</script>
